module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#f8f8ff","theme_color":"#f8f8ff","display":"minimal-ui","icon":"src/images/enterline-logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"e952b30c279c52eb61824cb659273277"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
